import { FlickeringGrid } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

// Stand-in brand mark for the mask demo — a diamond as an inline SVG data
// URI (no binary asset needed). Real consumers pass a logo URL, e.g.
// maskImage="/logo-mark.png".
const DIAMOND_MASK = `data:image/svg+xml,${encodeURIComponent(
  "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><polygon points='50,4 96,50 50,96 4,50' fill='white'/></svg>",
)}`;

export function FlickeringGridDemo() {
  return (
    <Section
      id="flickering-grid"
      title="FlickeringGrid"
      description="Canvas background of softly flickering squares. Default colour reads --accent so it re-tints per studio + dark mode. Pauses off-screen; static under reduced motion."
    >
      <VariantBlock label="Default (accent)">
        <div className="relative h-40 w-72 overflow-hidden rounded-2xl border border-border">
          <FlickeringGrid className="absolute inset-0" />
          <div className="relative flex h-full items-center justify-center text-sm font-medium">
            Hero backdrop
          </div>
        </div>
      </VariantBlock>

      <VariantBlock label="Density + opacity" caption="squareSize / gridGap / maxOpacity">
        <div className="relative h-40 w-72 overflow-hidden rounded-2xl border border-border">
          <FlickeringGrid
            className="absolute inset-0"
            squareSize={3}
            gridGap={4}
            maxOpacity={0.5}
            flickerChance={0.5}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Token colour override" caption='color="hsl(var(--primary))"'>
        <div className="relative h-40 w-72 overflow-hidden rounded-2xl border border-border bg-card">
          <FlickeringGrid className="absolute inset-0" color="hsl(var(--primary))" maxOpacity={0.25} />
        </div>
      </VariantBlock>

      <VariantBlock label="Logo-masked" caption='maskImage={logoUrl} — flicker shows only inside the mark'>
        <div className="relative h-40 w-72 overflow-hidden rounded-2xl border border-border bg-card">
          <FlickeringGrid
            className="absolute inset-0"
            maskImage={DIAMOND_MASK}
            maxOpacity={0.6}
            flickerChance={0.6}
          />
        </div>
      </VariantBlock>

      <VariantBlock
        label="Dual-panel bleed"
        caption="two masked instances, maskPosition left/right anchored off-edge (the auth front-door pattern)"
      >
        <div className="relative h-40 w-72 overflow-hidden rounded-2xl border border-border bg-card">
          {/* Background: two masked panels bleeding in from each edge, diamonds
              facing inward (maskPosition right on the left panel, left on the
              right panel) so they frame the centered auth card. */}
          <FlickeringGrid
            className="absolute inset-y-0 left-0 w-2/3"
            maskImage={DIAMOND_MASK}
            maskPosition="right"
            maxOpacity={0.6}
            flickerChance={0.6}
          />
          <FlickeringGrid
            className="absolute inset-y-0 right-0 w-2/3"
            maskImage={DIAMOND_MASK}
            maskPosition="left"
            maxOpacity={0.6}
            flickerChance={0.6}
          />
          {/* Overlay: the auth card sitting between the panels. */}
          <div className="absolute inset-0 z-10 grid place-items-center">
            <div className="rounded-lg border border-border bg-card px-4 py-2 text-sm font-medium whitespace-nowrap shadow-sm">
              Sign in
            </div>
          </div>
        </div>
      </VariantBlock>
    </Section>
  );
}
